<template>
  <div>
    <HelpCenterHeader v-if="!isH5"></HelpCenterHeader>
    <template v-if="errInfo.show">
      <EmptyState :emptyType="errInfo.type" @tryAgain="errInfo.fun" />
    </template>
    <template v-else>
      <div class="feedback-modules" v-r-loading="loading">
        <template v-if="gotData">
          <Submit
            v-if="mode === 'submit'"
            :feedbackInfo="feedbackInfo"
            @submit="onSubmit"
            :uid="selfInfo.uid"
          ></Submit>
          <Submitted
            v-if="mode === 'submitted'"
            :showContactUs="showContactUs"
            :uid="selfInfo.uid"
          ></Submitted>
          <UnSubmit
            v-if="mode === 'unsubmittable'"
            :reason="unsubmittableReason"
            :uid="selfInfo.uid"
          ></UnSubmit>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import api from '@/api';
import HelpCenterHeader from '@/components/HelpCenterHeader';
import Submitted from './Submitted/index.vue';
import UnSubmit from './UnSubmit/index.vue';
import Submit from './Submit/index.vue';
import { get } from 'lodash-es';
import { FEEDBACK_STATUS, FEEDBACK_ERROR_NO, APPLY_TYPE } from './const';
import EmptyState from '@/components/EmptyState';

export default {
  name: 'feedback', // 少餐错餐
  components: {
    HelpCenterHeader,
    Submitted,
    UnSubmit,
    Submit,
    EmptyState,
  },
  data() {
    return {
      currentApplyType: 'feedback',
      applyTypeRouteMap: {
        [APPLY_TYPE.FEEDBACK]: 'feedback',
        [APPLY_TYPE.MISS_ORDER]: 'missOrder',
      },
      gotData: false,
      mode: null,
      loading: false,
      errInfo: {
        show: false,
        type: '',
        fun: null,
      },
      feedbackInfo: null
    };
  },
  computed: {
    ...mapState({
      isH5: ({ common }) => common.isH5,
      selfInfo: ({ common }) => common.sidebar.selfInfo,
    }),
  },
  methods: {
    // 判断是否在申请流程中,如果在流程中，且不为当前类型，则跳入对应类型
    // 申请类型 0 没有申请 3 少餐售后申请 4 未收到餐申请。如果当前不是4，就通过这个类型的枚举跳转到对应的详情页中
    async judgeOnApply(applyType) {
      return new Promise((resolve) => {
        const typeName = this.applyTypeRouteMap[applyType];
        if (applyType && typeName !== this.currentApplyType) {
          this.$router.replace({
            name: typeName,
            query: this.$route.query,
          });
          resolve(true);
        } else {
          resolve(false);
        }
      });
    },
    async getFeedbackInfo() {
      const orderId = get(this, '$route.query.orderId', '');
      if (!orderId) {
        return;
      }
      try {
        this.loading = true;
        const res = await api.getMissItemInfo({
          orderId,
        });
        this.loading = false;
        this.errInfo.show = false;
        // 只在第一次请求时判断申请类型
        if (this.gotData === false) {
          let needJump = await this.judgeOnApply(res.applyType);
          // 需要跳转其他页面时不再进行页面渲染
          this.gotData = !needJump;
        }
        const status = get(res, 'status', null);
        status === FEEDBACK_STATUS.SUBMITTED
          ? this.showSubmitted(true)
          : this.showSubmit(res);
      } catch (err) {
        this.loading = false;
        let errno = get(err, 'errno', null);
        if (
          errno === FEEDBACK_ERROR_NO.OVER_TIME ||
          errno === FEEDBACK_ERROR_NO.UN_FINISH
        ) {
          this.gotData = true;
          if (errno === FEEDBACK_ERROR_NO.OVER_TIME) {
            this.showUnsubmittable('overtime');
          }
          if (errno === FEEDBACK_ERROR_NO.UN_FINISH) {
            this.goOrderList();
          }
        } else {
          this.errInfo = {
            show: true,
            type: 'noNetwork',
            fun: this.getFeedbackInfo,
          };
        }
      }
    },
    // 展示提交申诉视图
    showSubmit(feedbackInfo) {
      this.mode = 'submit';
      this.feedbackInfo = feedbackInfo;
    },
    // 展示无法提交视图
    showUnsubmittable(reason) {
      this.unsubmittableReason = reason;
      this.mode = 'unsubmittable';
    },
    // 展示已提交视图
    showSubmitted(showContactUs) {
      // 如果showContactUs为 true  则为非当次提交成功进入
      this.showContactUs = showContactUs;
      this.mode = 'submitted';
    },
    // 当提交完成时展示已提交页面
    onSubmit() {
      this.showSubmitted(false);
    },
    goOrderList() {
      this.$router.push({
        path: '/order/',
      });
    },
  },
  created() {
    this.getFeedbackInfo();
  },
};
</script>
